/**
 * Copyright © 2020-21 Robert Bosch Engineering and Business Solutions Private Limited. All Rights Reserved.
   NOTICE:  All information contained herein is, and remains the property of Robert Bosch Engineering and Business Solutions Private
   Limited. Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is
   obtained from Robert Bosch Engineering and Business Solutions Private Limited.
*/

import { Component, OnInit } from '@angular/core';
import { AccountControllerService } from 'src/app/services/Platform/services';
import { AsideCard } from '../../shared/aside-nav-card/aside-nav-card.component';
import { Router } from '@angular/router';
import { ACCOUNT_ICON, CREATE } from 'src/app/shared/constants/strings';
import { RightsideNavitemsService } from 'src/app/providers/rightside-navitems.service';
import { ResponseHandlerService } from 'src/app/providers/response-handler-service';
import { BciLoaderService } from '@bci-web-core/core';

/**
  * @ngdoc component
  * @name account.component:createAccount
  *
  *
  * @description
  * description: To create new accounts.
  *
*/
@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss']
})
export class CreateAccountComponent implements OnInit {
  public jsonFileLoaded;
  public showSpinner :any;
  public pageKey: string;
  public accountIcon;
  asideMenus: Array<AsideCard>;
  constructor(private accountControllerService: AccountControllerService,
    private responseHandlerService: ResponseHandlerService, private router: Router,
    private rightsideNavitemsService: RightsideNavitemsService, private loaderService: BciLoaderService) { }

  ngOnInit() {
    this.jsonFileLoaded = 'accounts';
    this.pageKey = 'account';
    this.rightsideNavitemsService.getRightsideNavItems(CREATE, this.pageKey).then(navItemsList => {
      this.asideMenus = navItemsList as Array<AsideCard>;
    });
    this.accountIcon = ACCOUNT_ICON;
  }

  /**
      * @ngdoc method
      * @name createAccount#createAccount
      *
      * @methodOf
      * account.controller:createAccount
      *
      * @description
      * Description: To create new account.
      *
      * @param {type} data
      * @return {type} null
    */
  public createAccount(data: any) {
    this.showSpinner = this.loaderService.showProgressBar();
    this.accountControllerService
      .createAccount({ body: data })
      .subscribe(
        resp => {
          this.loaderService.hideProgressBar(this.showSpinner);
          this.responseHandlerService.returnToastMessage('success', 'ACCOUNT_CREATE_SUCCESS');
          this.router.navigate(['accounts/manage-accounts']);
        },
        err => {
          this.loaderService.hideProgressBar(this.showSpinner);
          this.responseHandlerService.returnToastMessage('error', err.error.message);
        }
      );
  }
}
